import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export default ({ children }) => (

    <Style>
        { children }
    </Style>
)


const Style = styled.div.attrs(props => ({
    className: 'heading'
}))`
    text-align: center;


    h1 {
        font-size: 8vmax;
        line-height: 1;
        margin: 0;
        letter-spacing: -.0375em;
        font-weight: 800;

        ${breakpoint('desktop')`
            font-size: 106px;
        `}
    }

    .subtitle p {
        font-size: 4.5vmax;
        letter-spacing: -.3px;
        font-weight: 600;
        line-height: 1;

        ${breakpoint('desktop')`
            font-size: 32px;
        `}
    }

    p {
        font-size: 18px;
        line-height: 1.3;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 5vh 0 0 0;
        display: flex;
        justify-content: center;
        flex-direction: column;

        > li {
            margin-top: .5em;
        }

        .btn {
            min-width: 40vw;
        }
        
        ${breakpoint('tablet')`
            flex-direction: row;

            > li {
                margin: 0 .5em;
            }

            .btn {
                min-width: 142px;
            }
        `}
    }


    .heading__screenshot {
        margin-top: 5vh;
        margin-bottom: 0;
        max-width: 950px;
        margin: 5vh auto 0 auto;
        
        img {
            margin-bottom: 0;
            object-fit: contain!important;
        }
    }

    .features {
        margin-left: -1vmax;
        margin-right: -1vmax;
        margin-top: calc(5vh - 4vmax);
        flex-direction: column;

        ${breakpoint('tablet')`
            flex-direction: row;
            flex-wrap: wrap;
        `}

        > li {
            padding-left: 1vmax;
            padding-right: 1vmax;
            margin: 4vmax 0 0 0;
            text-align: left;


            ${breakpoint('tablet')`
                max-width: calc(100%/3);
            `}
        }
    }
`